import styled, { keyframes } from 'styled-components';

const loadingAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export type ShellProps = {
  height?: number | string
  width?: number | string
};

export const Shell = styled.div<ShellProps>`
  animation: ${loadingAnimation} 2s ease infinite;
  background: linear-gradient(90deg, #D3D2D6, #EEEEF0);
  background-size: 200% 200%;
  border-radius: 3px;
  display: block;
  height: ${props => typeof props.height === 'number' ? props.height + 'px' : props.height};
  width: ${props => typeof props.width === 'number' ? props.width + 'px' : props.width};
`;
